<template>
  <transition name="fade">
    <div v-show="is_active">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: ""
    }
  },

  data: () => ({
    is_active: false
  })
};
</script>
